import { css } from 'styled-components'

export default value => css`
  opacity: ${value};
  -ms-filter: progid:dximagetransform.microsoft.alpha(Opacity=${value * 100});
  filter: alpha(opacity=${value * 100});
`
